// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ec-typing {
	0% {
		transform: translateY(0);
		opacity: 0.35;
	}
	50% {
		transform: translateY(-6px);
		opacity: 1;
	}
	100% {
		transform: translateY(0);
		opacity: 0.35;
	}
}
.typing-dot {
	background: #7351fd;
	opacity: 0.35;
	animation: ec-typing 0.9s infinite;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/common/components/AIChatBubble/aiassistant.css"],"names":[],"mappings":"AAAA;CACC;EACC,wBAAwB;EACxB,aAAa;CACd;CACA;EACC,2BAA2B;EAC3B,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,aAAa;CACd;AACD;AACA;CACC,mBAAmB;CACnB,aAAa;CACb,kCAAkC;AACnC","sourcesContent":["@keyframes ec-typing {\n\t0% {\n\t\ttransform: translateY(0);\n\t\topacity: 0.35;\n\t}\n\t50% {\n\t\ttransform: translateY(-6px);\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: translateY(0);\n\t\topacity: 0.35;\n\t}\n}\n.typing-dot {\n\tbackground: #7351fd;\n\topacity: 0.35;\n\tanimation: ec-typing 0.9s infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
